// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Loader, Select, Text } from '@mantine/core';
import { FC } from 'react';
import { IconBrandGmail, IconChevronDown } from '@tabler/icons';
import { useNavigate } from 'react-router-dom';
import { useGoogleAccounts } from '../../../../Service/hooks/useGoogleAccounts';
import { DataS } from '../../../../Service/DataS';

interface Props {
  connectedAccountId?: string | null;
  handleChange: (externalAccountId: string | null) => void;
}

const GoogleGmailAccounts: FC<Props> = ({ connectedAccountId, handleChange }) => {
  const navigate = useNavigate();
  const { loading, googleAccounts } = useGoogleAccounts();
  const candidates = googleAccounts.filter((acc) => acc.hasSendMailScope);
  const noCandidate = candidates.length === 0;

  if (!loading && noCandidate) {
    return (
      <Text>
        Sie haben noch kein Google-Konto verbunden. Bitte konfigurieren Sie in{' '}
        <Text span color="blue" variant="link" sx={{ cursor: 'pointer' }} onClick={() => navigate('/settings/google')}>
          diesem Abschnitt
        </Text>{' '}
        ein Konto mit der Berechtigung zum Senden von E-Mails.
      </Text>
    );
  }

  return (
    <Select
      required
      my="sm"
      icon={loading ? <Loader size="xs" /> : <IconBrandGmail size={16} />}
      label="Konto"
      placeholder="Konto auswählen"
      onChange={(accountId) => handleChange(accountId)}
      value={connectedAccountId}
      data={DataS.mapGoogleAccounts(candidates)}
      styles={{ rightSection: { pointerEvents: 'none' } }}
      rightSection={<IconChevronDown size={16} />}
      rightSectionWidth={25}
    />
  );
};

export default GoogleGmailAccounts;
